import { z } from 'zod';

import { makeFeatureFlagPayloadValidator } from './utils';

export const featureFlagWithPromptTemplateId = makeFeatureFlagPayloadValidator({
  schema: z.object({
    promptTemplateId: z.string().uuid().nullable(),
  }),
  defaultEnabled: false,
  defaultValue: { promptTemplateId: null },
});
